const indexedPaths = {
  "fastqrgenerator.com": ["/", "/contact-us"],
  "qrcreator.com": ["/", "/contact-us"],
  "onlineqrcode.com": [],
  "app.onlineqrcode.com": [],
  "qrnow.com": [],
  "app.qrnow.com": [],
};

module.exports = {
  indexedPaths,
};
